// @ngInject
const config = ($stateProvider) => {
  $stateProvider.state('configuration.internalApi', {
    url: '/internal-api',
    templateUrl: 'main/configuration/internalApi/internalApi.tpl.html',
    data: { pageTitle: 'Internal API' },
  });
};

angular.module('configuration.internalApi', []).config(config);
